import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ShopIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M4.92886 8.22547C4.99698 7.95786 5.21443 7.73053 5.49057 7.73053C5.76671 7.73053 5.98416 7.95786 6.05228 8.22547C6.27254 9.09065 7.05683 9.73053 7.99057 9.73053C8.92431 9.73053 9.7086 9.09065 9.92886 8.22547C9.99698 7.95786 10.2144 7.73053 10.4906 7.73053C10.7667 7.73053 10.9842 7.95786 11.0523 8.22547C11.2725 9.09065 12.0568 9.73053 12.9906 9.73053C14.0154 9.73053 14.8602 8.9597 14.9768 7.96619C14.9949 7.812 14.9544 7.65824 14.885 7.51938L12.267 2.28332C12.0976 1.94453 11.7513 1.73053 11.3725 1.73053H4.6086C4.22983 1.73053 3.88357 1.94453 3.71418 2.28332L1.09614 7.51938C1.02672 7.65824 0.986209 7.812 1.00431 7.96619C1.12092 8.9597 1.96573 9.73053 2.99057 9.73053C3.92431 9.73053 4.7086 9.09065 4.92886 8.22547Z"
		/>
		<path
			fill="currentColor"
			d="M3.01079 10.7305C4.05518 10.7305 4.97364 10.1974 5.51079 9.38897C6.04793 10.1974 6.9664 10.7305 8.01079 10.7305C9.05518 10.7305 9.97366 10.1974 10.5108 9.38897C11.0479 10.1974 11.9664 10.7305 13.0108 10.7305C13.3538 10.7305 13.6833 10.673 13.9902 10.5671V14.2305C13.9902 15.0589 13.3187 15.7305 12.4902 15.7305H10.5C10.2239 15.7305 10 15.5066 10 15.2305V13.7305C10 13.1782 9.55229 12.7305 9 12.7305H7C6.44772 12.7305 6 13.1782 6 13.7305V15.2305C6 15.5066 5.77614 15.7305 5.5 15.7305H3.49023C2.66181 15.7305 1.99023 15.0589 1.99023 14.2305V10.5525C2.30876 10.6677 2.6524 10.7305 3.01079 10.7305Z"
		/>
	</svg>
))
